import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService, DASHBOARDS, METABASE_CF_API } from '../core/api.service';
import { SessionService } from '../core/session.service';
import { Dashboard } from '../shared/model/company';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  dashboards$: Observable<Dashboard[]> = of([]);

  constructor(
    private api: ApiService,
    private session: SessionService
  ) {
    combineLatest({
      companyId: this.session.currentCompanyId$,
      permissions: this.session.permissions$,
    }).subscribe({
      next: ({ companyId, permissions }) => {
        if (companyId && permissions?.roles?.company) {
          this.dashboards$ = this.api
            .get<{ items: Dashboard[] }>(DASHBOARDS(companyId))
            .pipe(map((result) => result?.items || []));
        } else {
          this.dashboards$ = of([]);
        }
      },
      error: () => {
        this.dashboards$ = of([]);
      },
    });
  }

  getDashboardUrl(id: string, body: any): Observable<string> {
    return this.api
      .post<{
        url: string;
      }>(METABASE_CF_API(this.session.currentCompanyId, id), body)
      .pipe(map((res) => res.url));
  }
}
